import AxiosInstanceCreator from 'services/api';
import qs from 'qs';
const authInstance = new AxiosInstanceCreator().create();

export const dashboardApi = {
  async getStatus() {
    return await authInstance.get(`/dashboard/getStatus`).then((res) => res.data);
  },

  async getTodayPtwStatus() {
    return await authInstance.get(`/dashboard/todayPtwStatus`).then((res) => res.data);
  },

  async getPermitTypeDistribution() {
    return await authInstance.get(`/dashboard/permitTypeDistribution`).then((res) => res.data);
  },

  async getWeeklyApprovedTrend() {
    return await authInstance.get(`/dashboard/weeklyApprovedTrend`).then((res) => res.data);
  }
};
